import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSurveyDetail } from "../../../actions/adminSurveyActions";
import Loader from "../../Loader";

const DetailRow = ({ label, value }) => (
  <div className="col-md-12" style={{ marginBottom: "12px" }}>
    <label style={{ fontWeight: 600 }}>{label}:&nbsp;</label>
    <span>{value || "-"}</span>
  </div>
);

const SurveyDetail = ({ match }) => {
  const dispatch = useDispatch();
  const surveyId = match.params.id;

  useEffect(() => {
    dispatch(getSurveyDetail(surveyId));
  }, [dispatch, surveyId]);

  const { survey = {}, user_loading } = useSelector((state) => state.surveyDetail || {});

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Manage
              <small> User Survey</small>
            </h1>
            <ol className="breadcrumb">
              <li>
                <Link to="/admin">
                  <i className="fa fa-dashboard"></i> Dashboard
                </Link>
              </li>
              <li>
                <Link to="/admin/surveys">
                  <i className="fa fa-list"></i> User Surveys
                </Link>
              </li>
              <li className="active">Survey Details</li>
            </ol>
          </section>

          <section className="content">
            <div className="box box-primary">
              <div className="box-header with-border">
                <h3 className="box-title">Survey response</h3>
              </div>
              <div className="box-body">
                <div className="row">
                  <DetailRow label="Student name" value={survey.userName || "Anonymous"} />
                  <DetailRow label="Student email" value={survey.userEmail || "—"} />
                  <DetailRow label="Submitted" value={survey.createdAt ? new Date(survey.createdAt).toLocaleString() : "-"} />
                  <DetailRow label="Exam(s)" value={(survey.examTypes || []).join(", ")} />
                  <DetailRow label="Age range" value={survey.ageRange} />
                  <DetailRow label="Heard about us" value={survey.heardAbout === "Other" ? survey.heardAboutOther : survey.heardAbout} />
                  <DetailRow label="Usage frequency" value={survey.usageFrequency} />
                  <DetailRow label="Main uses" value={(survey.mainUses || []).join(", ") + (survey.mainUsesOther ? ` (${survey.mainUsesOther})` : "")} />
                  <DetailRow label="Device" value={survey.device === "Other" ? survey.deviceOther : survey.device} />
                  <DetailRow label="Overall satisfaction" value={survey.satisfaction} />
                  <DetailRow label="Ease of use" value={survey.easeOfUse} />
                  <DetailRow label="Most value" value={survey.mostValue === "Other" ? survey.mostValueOther : survey.mostValue} />
                  <DetailRow label="Biggest challenge" value={survey.biggestChallenge === "Other" ? survey.biggestChallengeOther : survey.biggestChallenge} />
                  <DetailRow
                    label="Technical problems"
                    value={(survey.technicalProblems || []).join(", ") + (survey.technicalProblemsOther ? ` (${survey.technicalProblemsOther})` : "")}
                  />
                  <DetailRow label="Likes most" value={survey.likesMost} />
                  <DetailRow label="One thing to improve" value={survey.improveOneThing} />
                  <DetailRow label="Study plan usefulness" value={survey.studyPlanUsefulness} />
                  <DetailRow label="Subscription willingness" value={survey.subscriptionWillingness} />
                  <DetailRow label="Reason not to subscribe" value={survey.notSubscribeReason === "Other" ? survey.notSubscribeReasonOther : survey.notSubscribeReason} />
                  <DetailRow label="Recommend score (0-10)" value={survey.recommendScore} />
                  <DetailRow label="Return weekly" value={survey.returnWeekly} />
                  <DetailRow label="Use daily" value={survey.useDaily} />
                  <DetailRow label="One sentence description" value={survey.oneSentenceDescription} />
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </Fragment>
  );
};

export default SurveyDetail;
